<template>
		<div class="distributor-information">
			<div class="common-header-wrap">
				<mt-header :title="$t('distributor.title.account_info')" class="common-header">
					<mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
				</mt-header>
			</div>
			<div class="user-avatar iconfont icon-xiangji" ref="upload_btn" @change="uploadAvatar($event)" style="padding-top: 2rem;">
				<img :src="user.avatar">
				<input type="file" accept="image/jpg,image/png,image/gif,image/bmp,image/jpeg">
			</div>
		<div class="form main-content">
			<div @click="onRegion">
				<flex-line v-if="!user.store_id" :is-link="true" :show-border="true">
					<span>{{ $t('distributor.account.deliver_area') }}</span>
					<div slot="right">
						<span>{{region_name}}</span>
					</div>
				</flex-line>
			</div>
			<flex-line class="field-line" :show-border="true"><span class="field-name">{{ $t('distributor.account.real_name') }}</span><div class="field-line-right" slot="right"><input class="field-input" v-model="user.real_name" /></div></flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">{{ $t('distributor.account.introduction') }}</span><div class="field-line-right" slot="right"><input class="field-input" type='textarea' v-model="user.introduce" /></div></flex-line>
			<div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="submitInformation">{{ $t('general.save') }}</div></div>
		</div>
		<region-picker ref="picker" v-on:onConfirm="onPickerConfirm"></region-picker>
	</div>
</template>

<script>

import { Toast } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import RegionPicker from '../../../components/RegionPicker'
import { uploadUserFile, updateUserInformation } from '../../../api/distributorUser'
import flexLine from '../../flexLine'
export default {
	components: {
		RegionPicker,
	flexLine
	},
	name: 'DistributorInformation',
	data () {
		return {
			region_name: ''
		}
	},
	mounted () {

	},
	computed: {
		...mapState({
			user: state => state.distributor.info
		})
	},
	created: function () {
		this.region_name = this.user.region_name
	},

	methods: {
		...mapMutations({
			distributorEdit: 'distributorEdit'
		}),
		onRegion (picker, values) {
			console.log('onRegion')
			console.log(this.$refs.picker.currentValue)
			this.$refs.picker.currentValue = true
		},
		onPickerConfirm (values) {

			this.user.region_name = this.getRegionStr(values)
			this.region_name = this.user.region_name
			this.user.region_id = values[values.length - 1].area_id
		},
		getRegionStr (values) {
			let title = ''
			for (let i = 0; i < values.length; i++) {
				const element = values[i]
				if (i !== 0) {
					title = title + ' ' + element.area_name
				} else {
					title = title + element.area_name
				}
			}
			return title
		},
		submitInformation () {
			updateUserInformation(this.user.real_name, this.user.introduce, this.user.region_id, this.user.region_name).then(res => {
				this.distributorEdit({ real_name: this.user.real_name, introduce: this.user.introduce, region_id: this.user.region_id, region_name: this.user.region_name })

				if (this.$route.query.from == 'register') {
					this.$router.push({ name: 'DistributorAuthentication' })
				} else {
					Toast(res.message)
				}
			}).catch(function (error) {
				Toast(error.message)
			})
		},
		uploadAvatar (event) {
			if (typeof (event.target.files[0]) === 'undefined') {
				return
			}
			let formdata = new FormData()

			formdata.append('file', event.target.files[0])
			formdata.append('type', 'avatar')
			uploadUserFile(formdata).then(res => {
				this.user.avatar = res.result.url
				this.distributorEdit({ avatar: this.user.avatar })
			}).catch(function (error) {
				Toast(error.message)
			})
		}
	}
}
</script>
<style  lang="scss" scoped>
	.main-content{background: #fff;padding:0 $pageSpace}
	.distributor-information {
		background: #fff;
		.user-avatar {
			position: relative;
			width: 5rem;
			height: 5rem;
			margin: 2rem auto;
			text-align: center;
			img {
				width: 100%;
				height: 100%
			}
			input {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				opacity: 0
			}
		}
		.user-avatar::before {
			position: absolute;
			font-size: 1.5rem;
			line-height: 5rem;
			left: 50%;
			margin-left: -.75rem;
			color: rgba(0, 0, 0, 0.5)
		}
		.menu-item {
			border-top: 1px solid #eee
		}
	}

</style>
